import { Helmet } from 'react-helmet';
import ThenapDetail from 'src/components/thenap-detail/ThenapDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

const Thenap = () => (
  <>
    <Helmet>
      <title>Thẻ nạp</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <Box sx={{ pt: 3 }}>
          <ThenapDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Thenap;
